var CaseStudyCTASection = (function() {
    return {
        init: init
    };
    
    function init() {
        uiBindings();
    }
  
    function uiBindings() {
        var csSideBarContainer = document.getElementById('csSidebarContainer'),
            footerCTASection = document.querySelector('.call-to-action'),
            footerHabitatSection = document.getElementById("footer-habitat"),
            sidebarHeight = 0;

        //JS for Sidebar Case Study Page
        if (csSideBarContainer && window.innerWidth > 979) {

            window.addEventListener("scroll", function() {
                var scroll = window.pageYOffset,
                    csCtaSideBarSection = document.querySelector('.cs-section-container'),
                    csCtaSideBarSecOffsetLeft = csCtaSideBarSection ? csCtaSideBarSection.offsetLeft : 0,
                    csCtaSideBarSecOffsetTop = csCtaSideBarSection ? csCtaSideBarSection.offsetTop : 0,
                    csCtaSideBarSectionHeight = csCtaSideBarSection ? csCtaSideBarSection.offsetHeight : 0,
                    footerCTASecHeight = footerCTASection ? footerCTASection.offsetHeight : 0,
                    footerHabitatSecHeight = footerHabitatSection ? footerHabitatSection.offsetHeight : 0,
                    footerTotalHeight = footerCTASecHeight + footerHabitatSecHeight,
                    csInfoWrapper = document.querySelector('.cs-info-wrapper'),
                    csInfoWrapperHeight = csInfoWrapper ? csInfoWrapper.offsetHeight - 285 + 63 : 0;

                if ((scroll > csCtaSideBarSecOffsetTop) && (csCtaSideBarSecOffsetTop + csCtaSideBarSectionHeight - footerTotalHeight - csInfoWrapperHeight > scroll)) {
                    csSideBarContainer.classList.add('cs-sticky-wrapper');
                    csSideBarContainer.classList.remove ('cs-bottom-wrapper');
                    csSideBarContainer.style.bottom = 'auto';
                    csSideBarContainer.style.left = csCtaSideBarSecOffsetLeft + 'px';
                } else {
                    csSideBarContainer.classList.remove('cs-sticky-wrapper');
                    if (scroll > csCtaSideBarSecOffsetTop) {
                        csSideBarContainer.classList.add('cs-bottom-wrapper');
                        sidebarHeight = (csSideBarContainer.offsetHeight < 645) ? 0 : 35;
                        csSideBarContainer.style.bottom = footerTotalHeight - csSideBarContainer.offsetHeight + sidebarHeight + 'px';
                    } 
                    csSideBarContainer.style.left = '0px';
                }
            });
        }
    }
})();

CaseStudyCTASection.init();

